import { PointerEventHandler, PointerEvent, useState } from 'react';
const initial = {
  event: null,
  isDragging: false,
  movement: [0, 0],
  velocity: 0
};
export const useDrag = cb => {
  const [start, setStart] = useState([0, 0]);
  const [startTime, setStartTime] = useState(0);
  const [isGrab, setIsGrab] = useState(false);
  const handlePointerDown = e => {
    setIsGrab(true);
    setStart([e.screenX, e.screenY]);
    setStartTime(Date.now());
  };
  const handlePointerUp = e => {
    if (e.type === 'pointerleave' && !isGrab) return;
    const interval = Date.now() - startTime;
    const x = e.screenX - start[0];
    const y = e.screenY - start[1];
    cb({
      event: e,
      isDragging: false,
      movement: [x, y],
      velocity: isGrab ? Math.sqrt(x ** 2 + y ** 2) / interval : 0
    });
    setStart([0, 0]);
    cb({
      ...initial,
      event: e
    });
    setIsGrab(false);
  };
  const handlePointerMove = e => {
    const interval = Date.now() - startTime;
    const x = e.screenX - start[0];
    const y = e.screenY - start[1];
    if (isGrab) {
      cb({
        event: e,
        isDragging: isGrab,
        movement: [x, y],
        velocity: isGrab ? Math.sqrt(x ** 2 + y ** 2) / interval : 0
      });
    }
  };
  return {
    onPointerDown: handlePointerDown,
    onPointerUp: handlePointerUp,
    onPointerMove: handlePointerMove,
    onPointerLeave: handlePointerUp
  };
};